module.exports = __webpack_public_path__ + "static/velvetzoo-og-image-1200-b7da71601f59a3f6aa7ad86c8b710cba.jpg";